export const APP_NAME = 'ABCDE'

export const APP_DESCRIPTION =
  'ABCDE is a multi-chain decentralized exchange for token swaps, concentrated liquidity, and native token wrap and unwrap on BSC Testnet and Arc Testnet.'

export const APP_DEFAULT_TITLE = `${APP_NAME} | Multi-chain Decentralized Exchange`

export const APP_KEYWORDS = [
  APP_NAME,
  `${APP_NAME} swap`,
  'decentralized exchange',
  'DEX',
  'multi-chain swap',
  'BSC Testnet DEX',
  'Arc Testnet DEX',
  'concentrated liquidity',
  'token swap',
  'native token wrap and unwrap',
  'Uniswap V3 style exchange',
]

export const APP_ROBOTS = 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'

export interface FaqEntry {
  question: string
  answer: string
}

export interface SeoPageConfig {
  title: string
  description: string
  path: string
  keywords?: string[]
}

export const SWAP_FAQS: FaqEntry[] = [
  {
    question: `What is ${APP_NAME}?`,
    answer: `${APP_NAME} is a multi-chain decentralized exchange where users can swap tokens, wrap or unwrap native assets, and manage concentrated liquidity positions on supported testnets.`,
  },
  {
    question: `How does ${APP_NAME} choose swap routes?`,
    answer: `${APP_NAME} checks multiple Uniswap V3 style fee tiers through QuoterV2 and uses the best available quote for the selected token pair.`,
  },
  {
    question: `Which networks does ${APP_NAME} support?`,
    answer: `${APP_NAME} currently supports BSC Testnet and Arc Testnet with chain-aware contracts, token lists, and wallet switching built into the interface.`,
  },
  {
    question: `Can ${APP_NAME} wrap and unwrap native tokens?`,
    answer: `${APP_NAME} supports native asset wrapping and unwrapping, such as WBNB and tBNB conversions, directly in the swap interface when a pool is not needed.`,
  },
]

export function getPageSeo(pathname: string): SeoPageConfig {
  switch (pathname) {
    case '/':
    case '/swap':
      return {
        title: `${APP_NAME} Swap | Multi-chain Token Swaps`,
        description: `${APP_NAME} lets you swap tokens, compare fee-tier quotes, and wrap or unwrap native assets across BSC Testnet and Arc Testnet.`,
        path: '/swap',
      }
    case '/pool':
      return {
        title: `${APP_NAME} Liquidity | Positions and Fee Tracking`,
        description: `Track concentrated liquidity positions, review fee tiers, and monitor earnings across supported ${APP_NAME} pools.`,
        path: '/pool',
      }
    case '/pool/add':
      return {
        title: `Add Liquidity | ${APP_NAME}`,
        description: `Create a new concentrated liquidity position, initialize a pool, or add liquidity to an existing ${APP_NAME} position.`,
        path: '/pool/add',
      }
    case '/pool/position':
      return {
        title: `Liquidity Position | ${APP_NAME}`,
        description: `Review liquidity, manage fees, and increase or remove capital from an ${APP_NAME} concentrated liquidity position.`,
        path: '/pool/position',
      }
    case '/tokens':
      return {
        title: `Supported Tokens | ${APP_NAME}`,
        description: `Browse the default token list available on ${APP_NAME}, including native assets, wrapped assets, and core trading pairs.`,
        path: '/tokens',
      }
    default:
      return {
        title: APP_DEFAULT_TITLE,
        description: APP_DESCRIPTION,
        path: pathname || '/',
      }
  }
}